<div *ngIf="order" class="mb-3 border-bottom-1 border-gray-200 pb-3">
  <span class="block text-600 text-sm mb-2 font-bold uppercase"><i class="pi pi-credit-card mr-1"></i> Pago MercadoPago</span>
  <div class="flex justify-content-between align-items-center text-sm mb-2">
    <span class="text-600">Estado MP</span>
    <p-tag [value]="order.mpStatus || '—'" [severity]="mpSeverity"></p-tag>
  </div>
  <div class="flex justify-content-between text-sm mb-2 gap-3">
    <span class="text-600">Payment ID</span>
    <span class="font-semibold text-900 text-right" style="word-break: break-all;">{{ order.mpPaymentId || '—' }}</span>
  </div>
  <div class="flex justify-content-between text-sm mb-2">
    <span class="text-600">Monto pagado</span>
    <span class="font-semibold text-green-700">{{ (order.amountPaid || 0) | currency:'PEN':'symbol' }}</span>
  </div>
  <div class="flex justify-content-between text-sm mb-2">
    <span class="text-600">Fecha de pago</span>
    <span class="font-semibold text-900">{{ (order.mpApprovedAt || order.paidAt) ? ((order.mpApprovedAt || order.paidAt) | peruDate:'dd/MM/yyyy h:mm a') : '—' }}</span>
  </div>
  <div *ngIf="paymentUrl" class="text-right mb-2">
    <a [href]="paymentUrl" target="_blank" rel="noopener" class="text-primary text-sm underline cursor-pointer"><i class="pi pi-external-link mr-1"></i> Ver pago en MercadoPago</a>
  </div>

  <span class="block text-600 text-xs mt-3 mb-2 font-bold uppercase">Historial de pago</span>
  <div class="flex justify-content-between text-xs mb-1" *ngIf="order.createdAt">
    <span class="text-600">Pedido creado</span><span class="text-800">{{ order.createdAt | peruDate:'dd/MM/yyyy h:mm a' }}</span>
  </div>
  <div class="flex justify-content-between text-xs mb-1" *ngIf="order.mpPreferenceCreatedAt">
    <span class="text-600">Checkout MP generado</span><span class="text-800">{{ order.mpPreferenceCreatedAt | peruDate:'dd/MM/yyyy h:mm a' }}</span>
  </div>
  <div class="flex justify-content-between text-xs mb-1" *ngIf="order.mpExpiresAt && !order.paidAt">
    <span class="text-600">Expira</span><span class="text-800">{{ order.mpExpiresAt | peruDate:'dd/MM/yyyy h:mm a' }}</span>
  </div>
  <div class="flex justify-content-between text-xs mb-1" *ngIf="order.mpApprovedAt">
    <span class="text-600">Pago aprobado</span><span class="text-green-700">{{ order.mpApprovedAt | peruDate:'dd/MM/yyyy h:mm a' }}</span>
  </div>
  <div class="flex justify-content-between text-xs mb-1" *ngIf="order.mpRejectedAt">
    <span class="text-600">Pago rechazado</span><span class="text-red-600">{{ order.mpRejectedAt | peruDate:'dd/MM/yyyy h:mm a' }}</span>
  </div>
  <div class="flex justify-content-between text-xs mb-1" *ngIf="order.mpExpiredAt">
    <span class="text-600">Pago expirado</span><span class="text-orange-600">{{ order.mpExpiredAt | peruDate:'dd/MM/yyyy h:mm a' }}</span>
  </div>

  <span class="block text-600 text-xs mt-3 mb-2 font-bold uppercase">Boleta</span>
  <div *ngIf="boletaLoading" class="text-xs text-500"><i class="pi pi-spin pi-spinner mr-1"></i> Cargando...</div>
  <div *ngIf="!boletaLoading && boleta" class="flex justify-content-between align-items-center gap-2">
    <div class="text-sm">
      <span class="font-semibold text-900 mr-2">{{ boleta.numeroCompleto }}</span>
      <p-tag [value]="boleta.envioCliente === 'ENVIADO' ? 'Enviada' : 'Emitida'" [severity]="boleta.envioCliente === 'ENVIADO' ? 'success' : 'info'" [rounded]="true"></p-tag>
    </div>
    <button pButton icon="pi pi-download" label="PDF" class="p-button-sm p-button-outlined w-auto" [loading]="downloading" (click)="descargarBoleta()"></button>
  </div>
  <div *ngIf="!boletaLoading && !boleta" class="flex justify-content-between text-sm">
    <span class="text-600">Estado</span>
    <p-tag value="Sin boleta" severity="warn" [rounded]="true"></p-tag>
  </div>
</div>
